"use strict";

angular.module('app.controllers.userLogin', []).//

config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('login', {
        url: '/login',
        templateUrl: 'views/login.html',
        controller: 'UserLoginCtrl',
        params: {
            notLoggedIn: false,
            'toState': 'main', // default state to proceed to after login
            'toParams': {}

        },
        breadcrumb: {
            ignore:true,
            initialState: true,
            // Use white space so Breadcrump sees this as new state
            name: 'x-center Login'
        }
    });
}]).//

// Controller for Login Process

controller("UserLoginCtrl", ['$scope', '$rootScope', '$http', '$state', '$translate', 'appConfig', 'viewMenuBarService', 'f_Interval', 'frontEndSettingsService', 'API',
        function ($scope, $rootScope, $http, $state, $translate, appConfig, viewMenuBarService, f_Interval, frontEndSettingsService, API) {
            $rootScope.$emit('loading-start');
            $scope.displayScreen = false;

            function loadUserInfoForCurrentlyLoggedInUser() {
                API().User.GetCurrentUser().$promise
                .then((user) => {
                    $rootScope.$emit('currentUserChanged', user);
                });
            }

            // When coming from unaothorized:
            f_Interval.unregisterAllIntervals();

            frontEndSettingsService
                .getFrontendSettings()
                .then(settings => {
                    if (settings.RestrictedModeEnabled === true) {
                        /* Login immediately as the RestrictedUser. */
                        $http({
                            url: appConfig().loginAPIURL,
                            method: "POST",
                            data: {
                                Password: "",
                                Userid: "RestrictedUser"
                            },
                            withCredentials: true
                        }).then(response => {
                            $rootScope.$emit("loading-stop");
                            if (response.data.isValid == true) {
                                loadUserInfoForCurrentlyLoggedInUser();

                                var s, p;
                                if (!s || s == "login") {
                                    s = appConfig().routeTo;
                                    p = {};
                                }

                                $state.go(s, p, {
                                    reload: "site",
                                    inherit: true,
                                    notify: true
                                });
                            }
                        });
                    }
                    else {
                        $scope.displayScreen = true;
                    }
                });

            $scope.PasswordHint = $translate.instant('TOOLTIP_LoginPassword');

            // Init Var
            $scope.loginIncorrect = false;
            $rootScope.surpressErrors = false;
            $scope.userPass = '';

            viewMenuBarService.setButtons({});
            viewMenuBarService.setFavorite();

            // Send call to check userdata
            $scope.checkuserdata = function () {
                // Send login and fetch response.
                // Valid => redirect, and set Vars
                // not Valid set var and show message
                //document.activeElement.blur();
                $rootScope.$emit('loading-start');

                $rootScope.blockAllInteraction = false;

                $http({
                    url: appConfig().loginAPIURL,
                    method: "POST",
                    data: {
                        "Password": $scope.userPass,
                        "Userid": $scope.userName
                    },
                    withCredentials: true
                }).then(function (response) {
                        $rootScope.$emit('loading-stop');
                        if (response.data.isValid == true) {
                            loadUserInfoForCurrentlyLoggedInUser();

                            var s,p;
                            if($rootScope.redirectBack)
                            {
                              s = $rootScope.redirectBack.toState.name;
                              p = $rootScope.redirectBack.toParams;
                            }
                            $rootScope.redirectBack = undefined;
                            if(!s ||s == 'login')
                            {
                                s = appConfig().routeTo;
                                p = {};
                            }

                            $state.go(s,p,{ reload: 'site',inherit: true, notify: true });

                        }else{
                            $scope.loginIncorrect = true;
                        }
                    }
                    ,function (data) {
                        $scope.loginIncorrect = true;
                        $rootScope.$emit('loading-stop');
                    });


                $scope.clearerrorfield = function () {
                    $scope.loginIncorrect = false;

                }

            }

        }


    ]
)
;
